import { render, staticRenderFns } from "./schedule-publish-modal.vue?vue&type=template&id=10685699&scoped=true"
import script from "./schedule-publish-modal.vue?vue&type=script&lang=js"
export * from "./schedule-publish-modal.vue?vue&type=script&lang=js"
import style0 from "./schedule-publish-modal.vue?vue&type=style&index=0&id=10685699&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10685699",
  null
  
)

export default component.exports